import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServiceDetail from './components/ServiceDetail';
import ComplianceSection from './components/ComplianceSection';

const ServicesPage = () => {
  useEffect(() => {
    document.title = 'Commercial Electrical Services Perth | NS Electrical WA';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <ServicesHero />
        <ServiceDetail />
        <ComplianceSection />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;